import { mapGetters } from 'vuex';
export default {
	computed: {
		...mapGetters('dictionary', ['getWarehouseList', 'getOrgList', 'getCarrierServiceList','getCarrierList']),
		...mapGetters('common', ['getCountryList']),
		//组织
		getOrgOpt() {
			return this.getOrgList
			// return this.getOrgList.map(function(item){
			//     return {
			//         label:item.name,
			//         value:item.id,
			//     }
			// })
		},
		//仓库
		getWarehouseOpt() {
			return this.getWarehouseList
			// return this.getWarehouseList.map(function (item) {
			// 	return {
			// 		label: item.label,
			// 		value: item.warehouseId,
			// 		attach: {
			// 			code: item.code
			// 		},
			// 	}
			// })
		},
		//承运商服务
		getCarrierServiceOpt() {
			return this.getCarrierServiceList.map(function (item) {
				return {
					...item,
					value: item.attach.carrierServiceCode,
				}
			})
		},
		getCarrierOpt() {
			return this.getCarrierList
		},
		// getCountryList() {
		// 	return [
		// 		{
		// 			label: "US[美国]",
		// 			value: "US"
		// 		},
		// 		{
		// 			label: "CA[加拿大]",
		// 			value: "CA"
		// 		}, {
		// 			label: "CN[中国]",
		// 			value: "CN"
		// 		}
		// 	]
		// },
	},
	methods: {
		reset() {
			this.formData = {};
			this.calcList = [];
			this.$refs.formbase.resetValidate();
		},
	},
}